import { useSafeState } from "ahooks";
import { Input } from "antd";
import { useCallback, useEffect, useRef } from "react";
import Wrap from "./wrap";

/**
 * 检测当前输入框是否自动填充
 * @param {HTMLInputElement} input
 */
function checkAutofill(input) {
  try {
    return input && input.matches("input:-webkit-autofill");
  } catch (error) {
    return false;
  }
}
/**
 * 输入框
 * @param { {autofillCheck?:boolean, noWrapper?: boolean, wrapClass?: string} & import("antd").InputProps | import("antd/es/input/TextArea").TextAreaProps} props 和antd input属性一致
 * @returns
 */
export default function HBInput(props) {
  const {
    placeholder,
    disabled,
    noWrapper,
    autofillCheck,
    wrapClass,
    ...other
  } = props;
  const ref = useRef();
  const [isFocus, setFocus] = useSafeState(false);

  const [isFilled, setFilled] = useSafeState(!!props.value);

  let InputAlia = Input;

  if (props.type && props.type === "textarea") {
    InputAlia = Input.TextArea;
  }

  // 检测自动填入功能，轮询300ms检查，超过3秒还未检查到，就不再检查
  const timeOutRef = useRef();
  const pollingCheckFn = useCallback(() => {
    timeOutRef.current = setTimeout(() => {
      if (ref.current?.input) {
        if (checkAutofill(ref.current.input)) {
          setFilled(true);
        } else {
          pollingCheckFn();
        }
      }
    }, 300);
  }, [setFilled]);

  useEffect(() => {
    if (autofillCheck) {
      pollingCheckFn();

      // 到最大时间销毁轮询
      setTimeout(() => {
        clearTimeout(timeOutRef.current);
      }, 3000);

      return () => clearTimeout(timeOutRef.current);
    }
  }, [autofillCheck, pollingCheckFn]);

  useEffect(() => {
    if (props.value || props.addonBefore) setFilled(true);
    else setFilled(false);
  }, [props.addonBefore, props.value, setFilled]);

  return (
    <Wrap
      isFilled={isFilled}
      isFocus={isFocus}
      isDisabled={disabled}
      placeholder={placeholder}
      noWrapper={noWrapper}
      className={wrapClass}
    >
      <InputAlia
        {...other}
        ref={ref}
        bordered={false}
        disabled={disabled}
        placeholder={noWrapper ? placeholder : null}
        onFocus={() => {
          setFocus(true);
          props.onFocus && props.onFocus();
        }}
        onInput={(e) => {
          if (e.target.value || props.addonBefore) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          props.onInput && props.onInput(e);
        }}
        onChange={(e) => {
          if (e.target.value || props.addonBefore) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          props.onChange && props.onChange(e);
        }}
        onBlur={(e) => {
          setFocus(false);
          if (e.target.value || props.addonBefore) {
            setFilled(true);
          } else {
            setFilled(false);
          }
          props.onBlur && props.onBlur(e);
        }}
      />
    </Wrap>
  );
}
